import commonJsModule from "compare-dependencies"

export default commonJsModule.default